import { put } from '../Services/http';
import { 
    MY_ACCOUNT_USER_INFO_SUBMIT_ERROR, 
    MY_ACCOUNT_USER_INFO_CLEAR_ERROR ,
    MY_ACCOUNT_USER_INFO_RECEIVE,
    MY_ACCOUNT_USER_INFO_LOAD_ERROR,
    MY_ACCOUNT_EMAIL_CHANGE_ERROR,
    MY_ACCOUNT_EMAIL_LOAD_ERROR,
    MY_ACCOUNT_EMAIL_CLEAR_ERROR,
    MY_ACCOUNT_EMAIL_CHANGE_RECEIVE,
    MY_ACCOUNT_PASSWORD_CHANGE_ERROR,
    MY_ACCOUNT_PASSWORD_CLEAR_ERROR,
    MY_ACCOUNT_PASSWORD_CHANGE_RECEIVE
} from "../constants";
import { catchError } from './Error.action';
import { addFlashMessage } from './FlashMessages.action';
import { generalErrorAdd } from './Error.action';
import { handleApiErrors } from '../Services/Error.service';

export const submitUserInfoError = (error) => ({
    type: MY_ACCOUNT_USER_INFO_SUBMIT_ERROR,
    payload: {
        error,
    },
});

export const clearUserInfoError = () => ({
    type: MY_ACCOUNT_USER_INFO_CLEAR_ERROR,
    payload: {
        errors: [],
    },
});

export const userInfoReceive = (userInfo) => ({
    type: MY_ACCOUNT_USER_INFO_RECEIVE,
    payload: userInfo
})

export const loadUserInfoError = (error) => ({
    type: MY_ACCOUNT_USER_INFO_LOAD_ERROR,
    payload: {
        error,
    },
});

export const saveUserInformation = (data) => async (dispatch, getState) => {
    const { payload } = getState()?.myAccountUserInfo;
    const updatedPayload = { ...payload }
    updatedPayload.userDetails = { ...data }
    try {
        const response = await put('/api/user/update', updatedPayload);
        const data = await response.json();
        dispatch(userInfoReceive(data));
    } catch (ex) {  
        await dispatch(catchError(ex, (error) => handleApiErrors(error, loadUserInfoError)));
        throw ex;
    }
}

export const saveEmailChange = (data) => async(dispatch, getState) => {
    let { payload } = getState()?.myAccountChangeEmail ?? {};
    payload = { ...payload, ...data };
    try {
        const response = await put('/api/user/change-email', payload);
        const data = await response.json();
        dispatch(emailChangeRecieve(data));
    } catch (ex) {
        await dispatch(catchError(ex, (error) => handleApiErrors(error, submitEmailChangeError)));
        throw ex;
    }
}

export const emailChangeRecieve = (data) => ({
    type: MY_ACCOUNT_EMAIL_CHANGE_RECEIVE,
    payload: {
        ...data
    },
})

export const submitEmailChangeError = (error) => ({
    type: MY_ACCOUNT_EMAIL_CHANGE_ERROR,
    payload: {
        error,
    },
});

export const clearEmailChangeError = () => ({
    type: MY_ACCOUNT_EMAIL_CLEAR_ERROR,
    payload: {
        errors: []
    },
});

export const savePasswordChange = (data) => async(dispatch, getState) => {
    let { payload } = getState()?.myAccountChangePassword ?? {};
    const requestPayload  = { ...payload?.newPasswordModel, ...data };
    try {
        const response = await put('/api/user/change-password', requestPayload);
        const data = await response.json();
        dispatch(passwordChangeReceive({ ...payload, newPasswordModel: data}));
    } catch (ex) {
        await dispatch(catchError(ex, (error) => handleApiErrors(error, submitPasswordChangeError)));
        throw ex;
    }
}

export const passwordChangeReceive = (data) => ({
    type: MY_ACCOUNT_PASSWORD_CHANGE_RECEIVE,
    payload: {
        ...data
    },
})

export const submitPasswordChangeError = (error) => ({
    type: MY_ACCOUNT_PASSWORD_CHANGE_ERROR,
    payload : {
        error,
    },
})

export const clearPasswordChangeError = () => ({
    type: MY_ACCOUNT_PASSWORD_CLEAR_ERROR,
    payload: {
        errors: []
    },
});